import React, { FC } from 'react';

import { UniversalFilterConstants } from '@app/hooks/use-filter-data';

import useTranslation from '@app/hooks/use-translation';

import { Filter, FilterItem, FilterQmOperatorsType, FilterUcid, Range } from '../types';
type FilterViewInputPropsType = {
  filterData: Filter & Range & Partial<FilterQmOperatorsType> & FilterUcid;
  getNameByValueKey(key: string): string;
};
const FilterViewInput: FC<FilterViewInputPropsType> = (props) => {
  const { filterData, getNameByValueKey } = props;

  return (
    <>
      {filterData?.filter.map((filter, index) => {
        if (Array.isArray(filter)) {
          return filter.map((filterItem, indexItem) => (
            <Markup
              key={indexItem}
              filter={filterItem}
              getNameByValueKey={getNameByValueKey}
              valLength={filterItem[indexItem]?.value.length}
            />
          ));
        }
        return (
          <Markup
            key={index}
            filter={filter}
            getNameByValueKey={getNameByValueKey}
            valLength={filter[index]?.value.length}
          />
        );
      })}
    </>
  );
};

export default FilterViewInput;

const Markup = ({
  filter,
  getNameByValueKey,
  valLength,
}: {
  filter: FilterItem;
  getNameByValueKey: (key: string) => string;
  valLength: number;
}) => {
  const { t } = useTranslation('components.filter');

  const { conditionsWithoutValue, conditionsWithoutValueDisplay } = UniversalFilterConstants();
  return (
    <div className={'relative  flex items-center '}>
      {filter.id && (
        <div className="min-w-max pr-[6px] text-[15px] leading-[18px] ">
          {getNameByValueKey(filter.id)}
        </div>
      )}
      {filter.condition && (
        <div className="flex justify-center items-center w-[22px] h-[22px]  text-2color text-[15px] leading-[16px] mr-[6px] pb-[2px] border border-b_dark rounded-full">
          {conditionsWithoutValue.includes(filter.condition)
            ? conditionsWithoutValueDisplay[filter.condition] || 'e'
            : filter.condition}
        </div>
      )}
      <div className={'pr-[16px] flex items-center gap-[5px]'}>
        {Array.isArray(filter.value)
          ? filter.value.map(
              (value, indexValue) =>
                value && (
                  <div className={'flex items-center'} key={indexValue}>
                    {indexValue <= value.length - 1 && indexValue === 0 && (
                      <div className={'pr-1.5'}>(</div>
                    )}
                    <div
                      className={
                        'bg-defaultBg w-fit text-[15px] leading-[18px] text-2color px-[8px] pt-[2px] pb-[3px] rounded-[4px]'
                      }
                    >
                      {value}
                    </div>
                    {indexValue < valLength - 1 && (
                      <div className="px-[4px] text-[15px] leading-[18px] ml-[5px] border rounded-full text-2color">
                        {t('or')}
                      </div>
                    )}
                    {indexValue === valLength - 1 && <div className={'pl-1.5'}>)</div>}
                    {/* {indexValue < filterData.filter[index]?.value.length - 1 && (
                      <div className="px-[4px] text-[15px] leading-[18px] ml-[5px] border rounded-full text-2color">
                        {t('or')}
                      </div>
                    )}
                    {indexValue === filterData.filter[index]?.value.length - 1 && (
                      <div className={'pl-1.5'}>)</div>
                    )} */}
                  </div>
                ),
            )
          : filter.value && (
              <div
                className={
                  'bg-defaultBg px-[8px] pt-[2px] pb-[3px] rounded-[4px] w-fit text-[15px] leading-[18px] text-2color'
                }
              >
                {filter.value}
              </div>
            )}
      </div>
    </div>
  );
};
